// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizontal-tab-navigation__list {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  padding: 4px;
  background-color: #eef1f5;
  border: 0;
  border-radius: 10px;
  scrollbar-width: none;
}
.horizontal-tab-navigation__list::-webkit-scrollbar {
  display: none;
}
.horizontal-tab-navigation__tab {
  flex: 0 0 auto;
  padding: 7px 16px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #60758d;
  font: inherit;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}
.horizontal-tab-navigation__tab:hover {
  color: #1a2b3c;
}
.horizontal-tab-navigation__tab:focus-visible {
  outline: 2px solid #0b63d1;
  outline-offset: 1px;
}
.horizontal-tab-navigation__tab--active {
  color: #004195;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.06);
}
.horizontal-tab-navigation__tab--active:hover {
  color: #004195;
}
.horizontal-tab-navigation__panel {
  padding-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/HorizontalTabNavigation/HorizontalTabNavigation.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAIE;EACE,cAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,gFACE;AAHN;AAOI;EACE,cAAA;AALN;AAQI;EACE,0BAAA;EACA,mBAAA;AANN;AAUE;EACE,cAAA;EACA,yBAAA;EACA,8EACE;AATN;AAYI;EACE,cAAA;AAVN;AAcE;EACE,iBAAA;AAZJ","sourcesContent":[".horizontal-tab-navigation {\n  &__list {\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n    overflow-x: auto;\n    padding: 4px;\n    background-color: #eef1f5;\n    border: 0;\n    border-radius: 10px;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  &__tab {\n    flex: 0 0 auto;\n    padding: 7px 16px;\n    border: 0;\n    border-radius: 7px;\n    background: transparent;\n    color: #60758d;\n    font: inherit;\n    font-weight: 600;\n    font-size: medium;\n    letter-spacing: 0.01em;\n    cursor: pointer;\n    transition:\n      color 0.15s ease,\n      background-color 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover {\n      color: #1a2b3c;\n    }\n\n    &:focus-visible {\n      outline: 2px solid #0b63d1;\n      outline-offset: 1px;\n    }\n  }\n\n  &__tab--active {\n    color: #004195;\n    background-color: #ffffff;\n    box-shadow:\n      0 1px 2px rgba(16, 24, 40, 0.08),\n      0 1px 3px rgba(16, 24, 40, 0.06);\n\n    &:hover {\n      color: #004195;\n    }\n  }\n\n  &__panel {\n    padding-top: 20px;\n  }\n}\n\n/////////////\n///\n///\n/// .horizontal-tab-navigation {\n//   &__list {\n//     display: flex;\n//     gap: 4px;\n//     overflow-x: auto;\n//     border-bottom: 1px solid #dbe4ee;\n//     scrollbar-width: thin;\n//   }\n\n//   &__tab {\n//     flex: 0 0 auto;\n//     padding: 8px 18px 8px;\n//     border: 0;\n//     border-bottom: 3px solid transparent;\n//     background: transparent;\n//     color: #60758d;\n//     font: inherit;\n//     font-weight: 600;\n//     font-size:medium;\n//     cursor: pointer;\n\n//     &:hover { color: #075dc5; }\n//     &:focus-visible { outline: 2px solid #075dc5; outline-offset: -2px; }\n//   }\n\n//   &__tab--active { color: #075dc5; border-bottom-color: #075dc5; background-color:aliceblue; }\n//   &__panel { padding-top: 16px; }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
